module.exports = __webpack_public_path__ + "images/category_lp/macbook/main-view_3cd95615166171d3d996343691894d94.png";